import { render } from "./PdfLabelRenderer.vue?vue&type=template&id=56680cc9&scoped=true"
import script from "./PdfLabelRenderer.vue?vue&type=script&lang=js"
export * from "./PdfLabelRenderer.vue?vue&type=script&lang=js"

import "./PdfLabelRenderer.vue?vue&type=style&index=0&id=56680cc9&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56680cc9"]])

export default __exports__